<template>
  <admin-layout isLayout="searchIdeas">
    <IdeaHeader isLayout="searchIdeas" title="Tüm Projeler"  :subTitle="subTitle" />
    <SearchForm
      class="idea-search-container"
      :searchText="searchText"
      @search-filter="ideaSearchFilter"
      @clear-search-filter="clearSearchFilter"
      isIdea="search-idea"
      isForm="product"
      suggestionTypeId="3"
      location="otoProduct"
    />
    <div style="margin: 0 15px" class="idea-search-table-container">
      <AdminTable
        :columns="columns"
        :rows="getIdea"
        @table-detail="cardDetail"
        location="otoProduct' : 'productization"
      />
      <div class="row mt-4 d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRecords"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
    <transition name="fade">
      <IdeaDetail
        v-if="isIdeaModal"
        @close="isIdeaModal = $event"
        :detailData="ideaModalData"
        isSuggestion="idea"
      />
    </transition>
  </admin-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { upload } from "../../services";

import AdminTable from "../../components/Admin/AdminTable.vue";
import SearchForm from "../../components/MyIdea/SearchForm.vue";
import IdeaHeader from "../../components/MyIdea/IdeaHeader.vue";
import IdeaDetail from "../../components/Main/Cards/Modals/CardDetail.vue";
import AdminLayout from "../../layouts/AdminLayout.vue";
export default {
  components: { AdminLayout, IdeaHeader, SearchForm, AdminTable, IdeaDetail },
  name: "Idea",
  data() {
    return {
      subTitle:"",
      isIdeaModal: false,
      ideaModalData: null,
      columns: [
        {
          label: "Fikir No.",
          field: "SuggestionNumber",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Fikir Sahibi",
          field: "CreatedCustomerName",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Proje Adı",
          field: "Title",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Proje Yılı",
          field: "ProjectYear",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Statü",
          field: "SuggestionStatusName",
          sortable: false,
          thClass: "vgt-center-align",
        },
      ],
      searchText: "",
      perPage: 15,
      currentPage: 1,
      ideaFilterData: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      totalRecords: "ideas/ideaProductTotalRecords",
    }),
    getIdea() {
      return this.$store.getters["ideas/getIdeaProductData"];
    },
  },
  watch: {
    async currentPage() {
      await this.searchFilter(this.ideaFilterData);
    },
  },
  methods: {
    async clearSearchFilter(event) {
      await this.searchFilter(event);
    },
    async ideaSearchFilter(event) {
      this.currentPage = 1;
      await this.searchFilter(event);
    },
    async searchFilter(event) {
      let tmpData = null;
      this.ideaFilterData = event;
      tmpData = {
        ...event,
        ...{
          pageSize: this.perPage,
          pageIndex: parseInt(this.currentPage - 1),
          loginUserId: this.user.Data.UserId,
        },
      };
      await this.$store.dispatch("ideas/deleteIdeaProductData");
      await this.$store.dispatch("ideas/setIdeaProductData", tmpData);
    },
    async cardDetail(item) {
      this.$store.dispatch("loading/setIsLoading", true);
      this.ideaModalData = item;
      this.ideaModalData.ProjectPresentationDocumentFiles = [];
      this.ideaModalData.DownloadFile = [];

      if (this.ideaModalData.FileIds && this.ideaModalData.FileIds.length > 0) {
        for await (let element of this.ideaModalData.FileIds) {
          const res = await upload.fetchDownloadFile(element);
          this.ideaModalData.DownloadFile.push({
            DownloadBinary: res.Data.DownloadBinary,
            Extension: res.Data.Extension,
            Filename: res.Data.Filename,
            Id: res.Data.Id,
          });
        }
      }
      if (
        this.ideaModalData.ProjectPresentationDocumentIds &&
        this.ideaModalData.ProjectPresentationDocumentIds.length > 0
      ) {
        for await (let element of this.ideaModalData
          .ProjectPresentationDocumentIds) {
          const res = await upload.fetchDownloadFile(element);
          this.ideaModalData.ProjectPresentationDocumentFiles.push({
            DownloadBinary: res.Data.DownloadBinary,
            Extension: res.Data.Extension,
            Filename: res.Data.Filename,
            Id: res.Data.Id,
          });
        }
      }
      this.$store.dispatch("loading/setIsLoading", false);
      this.isIdeaModal = true;
    },
  },
  async created() {
    this.searchText = this.$route.query.searchText;
    if (this.getIdea.length == 0 || this.searchText != "") await this.searchFilter();
  },
};
</script>